import PropTypes from 'prop-types'
import React, { Component } from "react"
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Row,
	Col,
	Button,
	Spinner,
} from "reactstrap"

import { ToastContainer } from "react-toastify";
import PlatformList from "./HandlerList";
import StoreHandleModal from "./StoreHandleModal";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import 'react-toastify/dist/ReactToastify.css';

// Utilities
import {
	createNotificationHelpers,
	loadStoreHandlesData,
	createStoreHandle as createStoreHandleAPI,
	updateStoreHandle as updateStoreHandleAPI,
	deleteStoreHandle as deleteStoreHandleAPI,
	transformStoreHandlesToTableData,
	STORE_HANDLER_TABLE_COLUMNS,
	MESSAGES
} from "../utils";

class StoreHandle extends Component {
	constructor(props) {
		super(props)
		this.state = {
			platform: [],
			loading: false,
			modal_standard_create: false,
			modal_standard_edit: false,
			storeHandle: {}
		}

		this.create_store_handle = this.create_store_handle.bind(this);
		this.edit_store_handle = this.edit_store_handle.bind(this);
		this.delete_store_handle = this.delete_store_handle.bind(this);

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_info = notifications.notify_info;
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}

	/**
	 * Loads store handles from API and updates state
	 * @param {boolean} showNotification - Whether to show success notification (default: false)
	 */
	loadHandles = async (showNotification = false) => {
		this.setState({ loading: false });

		const handles = await loadStoreHandlesData(this.notify_error);

		if (handles) {
			const data = transformStoreHandlesToTableData(
				handles,
				STORE_HANDLER_TABLE_COLUMNS,
				this.edit_store_handle,
				this.delete_store_handle
			);
			this.setState({ platform: data, loading: true });
			if (showNotification) {
				this.notify_success(MESSAGES.STORE_HANDLER_LOADED_SUCCESS);
			}
		}
	}

	componentDidMount() {
		this.loadHandles();
	}

	create_store_handle = () => {
		this.toggleCreateModal();
	}

	edit_store_handle = (id, name, handle, hotdeals_handle, domain, store, is_active) => {
		this.setState({
			storeHandle: {
				id,
				name,
				handle,
				hotdeals_handle,
				domain,
				store,
				is_active
			},
			modal_standard_edit: true,
		});
	}

	/**
	 * Deletes a store handle
	 */
	delete_store_handle = async (id) => {
		const answer = window.confirm("Are you sure you want to delete this store handle?");
		if (!answer) {
			return;
		}

		const success = await deleteStoreHandleAPI(
			id,
			this.notify_success,
			this.notify_error
		);

		if (success) {
			await this.loadHandles();
		}
	}

	/**
	 * Updates a store handle
	 */
	updateStoreHandle = async (e) => {
		e.preventDefault();
		const { id, ...update_records } = this.state.storeHandle;

		const success = await updateStoreHandleAPI(
			{
				id,
				update_records: {
					...update_records,
					is_active: Boolean(update_records.is_active)
				}
			},
			this.notify_error
		);

		if (success) {
			this.setState({ modal_standard_edit: false, storeHandle: {} });
			this.notify_success(MESSAGES.STORE_HANDLER_UPDATED_SUCCESS);
			await this.loadHandles();
		}
	}

	/**
	 * Creates a new store handle
	 */
	handlePlatformSubmit = async (e) => {
		e.preventDefault();

		const success = await createStoreHandleAPI({ ...this.state.storeHandle }, this.notify_error);

		if (success) {
			this.setState({ modal_standard_create: false, storeHandle: {} });
			this.notify_success(MESSAGES.STORE_HANDLER_CREATED_SUCCESS);
			await this.loadHandles();
		}
	}

	handleInputChange = (e) => {
		const { name, value, checked, type } = e.target;
		this.setState({
			storeHandle: {
				...this.state.storeHandle,
				[name]: type === "checkbox" ? checked : value
			}
		});
	}

	/**
	 * Toggles create modal
	 */
	toggleCreateModal = () => {
		this.setState(prevState => ({
			storeHandle: {},
			modal_standard_create: !prevState.modal_standard_create,
		}));
	}

	/**
	 * Toggles edit modal
	 */
	toggleEditModal = () => {
		this.setState(prevState => ({
			modal_standard_edit: !prevState.modal_standard_edit,
		}));
	}

	render() {
		const {
			loading,
			platform,
		} = this.state;

		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Auto BCL</title>
					</Helmet>
					<Container fluid>
						{/* Render Breadcrumb */}
						<Breadcrumbs
							title={this.props.t("Auto BCL")}
							breadcrumbItem={this.props.t("Auto BCL")}
						/>

						<ToastContainer />
						<Row>

							<Col xl={12}>
								{loading ? (
									<React.Fragment>
										<div className="" style={{ "textAlign": "right", "paddingBottom": "10px" }}>
											<span className="loading"></span>
											<Button
												color="primary"
												className="btn btn-primary waves-effect waves-light"
												onClick={this.create_store_handle}
												data-toggle="modal"
												data-target="#myModal"
											>Create</Button>
										</div>
										<PlatformList customers={platform} />

									</React.Fragment>
								) : (
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
										<Spinner color="primary" />
										<span style={{ marginLeft: '10px' }}>Loading ...</span>
									</div>
								)}
							</Col>

							<StoreHandleModal
								isOpen={this.state.modal_standard_create}
								toggle={this.toggleCreateModal}
								onSubmit={this.handlePlatformSubmit}
								storeHandle={this.state.storeHandle}
								onInputChange={this.handleInputChange}
								mode="create"
								title="Create Auto BCL Info"
							/>

							<StoreHandleModal
								isOpen={this.state.modal_standard_edit}
								toggle={this.toggleEditModal}
								onSubmit={this.updateStoreHandle}
								storeHandle={this.state.storeHandle}
								onInputChange={this.handleInputChange}
								mode="edit"
								title="Edit Auto BCL Info"
							/>
						</Row>
					</Container>
				</div>

			</React.Fragment >
		)

	}
}

StoreHandle.propTypes = {
	t: PropTypes.any
}

export default withTranslation()(StoreHandle)
